var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"v-spacer",class:[_vm.data.class, _vm.data.staticClass]},'div',_vm.data.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }